import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  ICharacterSlotConfiguration,
  specialityType,
} from 'src/app/api/interfaces/configuration.interface';
import { IComleteSlot } from '../components/character-slots/character-slots.component';

@Injectable({
  providedIn: 'root',
})
export class MapModalService {
  public currentModalType:
    | 'exploration'
    | 'acquisition'
    | 'close'
    | 'buyLandInfo'
    | 'buyLandConfirm'
    | 'buildCityInfo'
    | 'buildCityConfirm'
    | 'hiringCharacter'
    | 'admin'
    | 'accelerator'
    | 'characterSelectGrid'
    | 'energyRestoring'
    | 'xpBoost'
    | 'homeCharacterSelect'
    | 'openSlot' = 'close';
  public openLandCoords:
    | {
        coordinateX: number;
        coordinateY: number;
      }
    | undefined;
  public openSlotInfo: IComleteSlot | undefined;
  // public hiringCharacterCoast: { GOLD: number; NEAR: number } | undefined;
  public pickedSlot: IComleteSlot | undefined;
  public characterSlotId: BehaviorSubject<number | undefined> =
    new BehaviorSubject<number | undefined>(undefined);
  public pickedCharacterSpeciality: BehaviorSubject<
    specialityType | undefined
  > = new BehaviorSubject<specialityType | undefined>('FARMER');
  public isCraftingBuilding: boolean = true;
  constructor() {}
  public calculateCardCount(
    cardValue: number,
    userCardQuantity: number,
    remainder: number
  ): { count: number; restoreValue: number } {
    const count = remainder / cardValue;
    const roundedCount = Math.floor(count);
    if (userCardQuantity > 0 && remainder > 0) {
      if (count < 1) {
        return { count: 1, restoreValue: remainder };
      } else {
        if (userCardQuantity >= roundedCount) {
          return {
            count: roundedCount,
            restoreValue: roundedCount * cardValue,
          };
        } else {
          return {
            count: userCardQuantity,
            restoreValue: userCardQuantity * cardValue,
          };
        }
      }
    } else {
      return { count: 0, restoreValue: cardValue };
    }
  }
}
